<div class="card" style="margin-top: 10px;" >
    <div class="header">
        <p style="font-size: 17px; color: #a5a8ad; text-align: left!important;" class="text-center">Agregar usuarios al proyecto</p>
    </div>

    
    <div class="body" >
     
      <div class="row">

       
        <form method="POST" #addForm="ngForm" (ngSubmit)="onSubmit(addForm)" style="width: 100%;">
          <div class="row">
            <div class="col-md-4">
              <label for="staticEmail2" style="float: right; margin: 0px;">Usuarios: </label>
            </div>
            <div class="col-md-4">
              <!-- <div *ngIf="agregar_usuario?.usuarios_proyecto.length != 0"> -->
                <select class="selectpicker form-control" multiple  [(ngModel)]="info.categoria" name="users" data-style="btn-info" data-size="6" data-show-subtext="true" data-live-search="true" title="Seleccia a los usuarios" required>
                  <option *ngFor="let agrega of agregar_usuario?.usuarios" value="{{agrega.id_us}}" >{{agrega.name}} {{agrega.last_name}}</option>
                </select>
                <a class="" style="float: right; cursor: pointer;" (click)="actualizar_list_users()">Actualizar Lista de Usuarios</a>
                
              <!-- </div> -->
                <!-- <input type="text" readonly class="form-control-plaintext" id="staticEmail2" value="email@example.com"> -->
              </div>
              <div class="col-md-4">
                 <button type="submit" class="btn btn-primary mb-2 btn-round" [disabled]="!addForm.form.valid">Guardar</button>
             </div>
          </div>
          


        </form>
      </div>
      <div class="row justify-content-md-center" style="margin-top: 25px;">
        <div class="col-md-4">
          <div *ngIf="agregar_usuario?.clientes.length == 0">
            <small style="margin-left: 20px;">
              No se tienen clientes en el proyecto
            </small>
          </div>

          <table class="table" *ngIf="agregar_usuario?.clientes.length != 0">
            <tbody>
              <tr>
                <th>Clientes</th>
                 <th>Eliminar</th>
              </tr>
              <tr *ngFor="let add of agregar_usuario?.clientes">
                <td>{{add.name}} {{add.last_name}}</td>
                <td><button type="button" class="btn btn-danger btn-round"  (click)="eliminaruserclient(add.id_u_p)"><i class="fa fa-trash" aria-hidden="true"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-8">
        
          <div *ngIf="agregar_usuario?.users_cat.length == 0">
            <small style="margin-left: 20px;">
              No se tienen usuarios en el proyecto
            </small>
          </div>

          <table class="table" *ngIf="agregar_usuario?.users_cat.length != 0">                        
            <tbody>
              <tr>
                <th> Lista de usuarios en el proyecto</th>
                 <th>Eliminar</th>
              </tr>
              <tr *ngFor="let us of agregar_usuario?.users_cat">
                <td>{{us.name}} {{us.last_name}}</td>
                <td><button type="button" class="btn btn-danger btn-round" (click)="eliminaruserproyect(us.id_u_p)"><i class="fa fa-trash" aria-hidden="true"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        
      </div>
      
    </div>
   
</div>